import { Component } from "@/decorators";
import OrigemAtendimentoModel from "@/models/origemAtendimentoModel";
import origemAtendimentoService from "@/services/origemAtendimentoService";

import EditComponentBase from "../editComponentBase";

@Component
export default class OrigemAtendimentoEditComponent extends EditComponentBase<OrigemAtendimentoModel> {
    private async beforeMount() {
        await this.setPropsCached(
            origemAtendimentoService,
            "origemAtendimento",
            new OrigemAtendimentoModel(),
            false,
            true,
        );
    }
}
